<template>
    <v-container class="header">
        <v-row no-gutters>
            <v-col class="d-flex justify-center align-center">
                <h4>Name</h4>
            </v-col>
            <v-col class="d-flex justify-center align-center">
                <h4>Location</h4>
            </v-col>
            <v-col class="d-flex justify-center align-center">
                <h4>Total Energy (kWh)</h4>
            </v-col>
            <v-col class="d-flex justify-center align-center">
                <h4>RM per kWh</h4>
            </v-col>
            <v-col class="d-flex justify-center align-center">
                <h4>Total RM</h4>
            </v-col>
            <v-col class="d-flex justify-center align-center">
                <h4>Date Listed</h4>
            </v-col>
            <v-col class="d-flex justify-center align-center">
                <h4></h4>
            </v-col>
        </v-row>
    </v-container>
    <p>{{ listings.length == 0 ? "No listings to be shown" : None }}</p>
    <div v-for="(listing, index) in listings" :key="index">
        <v-container class="listing">
            <v-row no-gutters>
                <v-col class="d-flex justify-center align-center">
                    <p>{{ listing.name }}</p>
                </v-col>
                <v-col class="d-flex justify-center align-center">
                    <p>{{ listing.location }}</p>
                </v-col>
                <v-col class="d-flex justify-center align-center">
                    <p>{{ listing.total_energy }}</p>
                </v-col>
                <v-col class="d-flex justify-center align-center">
                    <p>{{ listing.rate_per_kwh }}</p>
                </v-col>
                <v-col class="d-flex justify-center align-center">
                    <p>{{ listing.total_price }}</p>
                </v-col>
                <v-col class="d-flex justify-center align-center">
                    <p>
                        {{
                            new Date(
                                listing.date.seconds * 1000
                            ).toLocaleDateString("en-GB", {
                                day: "numeric",
                                month: "numeric",
                                year: "numeric",
                            })
                        }}
                    </p>
                    
                </v-col>
                <v-col class="d-flex justify-center align-center">
                    <v-menu transition="scale-transition">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                color="grey"
                                variant="text"
                                v-bind="props"
                                @click="onOpenDialog(listing.total_price,listing.id)"
                                >Buy
                                <v-dialog
                                    v-model="dialog"
                                    width="unset"
                                    transition="dialog-top-transition"
                                    persistent
                                    
                            
                                >
                                    <v-card>
                                        <v-card-title class="text-center">
                                            Congrats!
                                        </v-card-title>
                                        <v-card-text class="text">
                                            You have saved
                                            <b
                                                >RM{{
                                                    savingAmount.toFixed(2)
                                                }}</b
                                            >
                                            on this transaction due to a
                                            generous donor.
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-btn
                                                color="#ffb700"
                                                block
                                                @click="
                                                    onCloseDialog
                                                "
                                                >Yay, Proceed</v-btn
                                            >
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-btn>
                            <v-tooltip
                                location="top"
                                v-if="
                                    'donation' in listing &&
                                    listing.donation != ''
                                "
                            >
                                <template v-slot:activator="{ props }">
                                    <v-icon color="#ffd876" v-bind="props">
                                        mdi-lightning-bolt
                                    </v-icon>
                                </template>
                                <span
                                    >{{listing.name}} will donate RM{{
                                        listing.donation
                                    }}
                                    worth of energy!</span
                                >
                            </v-tooltip>
                            <v-tooltip location="top" v-else>
                                <template v-slot:activator="{ props }">
                                    <v-icon color="#dfdfdf" v-bind="props">
                                        mdi-lightning-bolt
                                    </v-icon>
                                </template>
                                <span>No donation</span>
                            </v-tooltip>
                        </template>
                    </v-menu>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name: "MarketplaceView",
    props: {
        listings: Array,
    },
    data() {
        return {
            show: false,
            dialog: false,
            savingAmount: 0,
            idealListingID: "",
        };
    },
    methods: {
        onOpenDialog(listingPrice,listingID) {
            this.savingAmount = Math.random() * (listingPrice/2);
            this.dialog = true;
            if (this.idealListingID == ""){
                this.idealListingID = listingID
            }
            
        },
        onCloseDialog() {
            this.dialog = false;
            if (this.idealListingID != ""){
                this.$emit("buy-listing", this.idealListingID);
                this.idealListingID = ""
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.listing {
    border-radius: 3px;
    margin-bottom: 7px;
    margin-top: 7px;
    padding: 5px 0;
    width: 90%;

    box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.1);

    transition: scale 0.2s;

    &:hover {
        scale: 1.02;
    }
}
.header {
    width: 90%;
    border-bottom: 2px solid $light-gray;
    margin-bottom: 20px;
}

.option {
    color: #ffc877;
}
h4 {
    text-align: center;
}
p {
    text-align: center;
}
</style>
